import { object, string } from "yup";

export type FormValues = {
  email: string;
};

export const validationSchema = object({
  email: string().email().required(),
});
